var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawTimeManagement4Ss6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 763.974,
    height: 808.891,
    viewBox: "0 0 763.974 808.891",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-646.001 -224.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1026.138,660.881a1.5,1.5,0,0,1-.393,1.024,1.3,1.3,0,0,1-.953.422H263.51a1.45,1.45,0,0,1,0-2.893h761.282a1.3,1.3,0,0,1,.953.423A1.5,1.5,0,0,1,1026.138,660.881Z",
    transform: "translate(383.836 203.317)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.725 224.029)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 261.371,
    cy: 261.371,
    r: 261.371,
    transform: "translate(0 55.753)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.964,434.793A224.589,224.589,0,0,1,715.19,615.334c-1.884,1.41-3.805,2.784-5.738,4.121a224.939,224.939,0,0,1-256.776,0c-1.933-1.337-3.854-2.711-5.738-4.121a224.925,224.925,0,0,1,0-361.081c1.884-1.41,3.805-2.784,5.738-4.121a224.939,224.939,0,0,1,256.776,0c1.933,1.337,3.854,2.711,5.738,4.121a224.589,224.589,0,0,1,90.775,180.541Z",
    transform: "translate(-319.692 -117.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.45,
    cy: 205.45,
    r: 205.45,
    transform: "translate(55.921 111.674)",
    fill: "#3E629C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.849,213.892a6.7,6.7,0,0,0-6.686,6.686v29.176a6.686,6.686,0,0,0,13.372,0V220.579a6.7,6.7,0,0,0-6.686-6.686Z",
    transform: "translate(-280.869 -116.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.687,247.116c-1.884-1.41-3.805-2.784-5.738-4.121a6.682,6.682,0,0,0-5.957,2.905l-16.424,24.107a6.685,6.685,0,1,0,11.051,7.525l16.424-24.107A6.643,6.643,0,0,0,656.687,247.116Z",
    transform: "translate(-261.189 -110.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.954,337.542a6.678,6.678,0,0,0-8.7-3.671l-27.037,10.978a6.686,6.686,0,0,0,5.033,12.388l27.037-10.978A6.7,6.7,0,0,0,719.954,337.542Z",
    transform: "translate(-249.837 -91.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.043,270.007,442.619,245.9a6.682,6.682,0,0,0-5.957-2.905c-1.933,1.337-3.854,2.711-5.738,4.121a6.643,6.643,0,0,0,.644,6.309l16.424,24.107a6.685,6.685,0,0,0,11.051-7.525Z",
    transform: "translate(-303.678 -110.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.282,344.848,378.246,333.87a6.686,6.686,0,0,0-5.033,12.388l27.037,10.978a6.686,6.686,0,0,0,5.033-12.388Z",
    transform: "translate(-316.914 -91.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.849,540.892a6.7,6.7,0,0,0-6.686,6.686v29.176a6.686,6.686,0,0,0,13.372,0V547.579a6.7,6.7,0,0,0-6.686-6.686Z",
    transform: "translate(-280.869 -46.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.043,543.008,639.619,518.9a6.685,6.685,0,1,0-11.051,7.525l16.424,24.107a6.682,6.682,0,0,0,5.957,2.906c1.933-1.337,3.854-2.711,5.738-4.121a6.643,6.643,0,0,0-.644-6.309Z",
    transform: "translate(-261.189 -51.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.282,447.848,689.246,436.87a6.686,6.686,0,0,0-5.033,12.388l27.037,10.978a6.686,6.686,0,0,0,5.033-12.388Z",
    transform: "translate(-249.837 -68.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.28,517.138a6.686,6.686,0,0,0-9.288,1.763l-16.424,24.107a6.643,6.643,0,0,0-.644,6.309c1.884,1.41,3.805,2.784,5.738,4.121a6.682,6.682,0,0,0,5.957-2.906l16.424-24.107a6.684,6.684,0,0,0-1.763-9.288Z",
    transform: "translate(-303.678 -51.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.954,440.542a6.678,6.678,0,0,0-8.7-3.671l-27.037,10.978a6.686,6.686,0,1,0,5.033,12.388l27.037-10.978a6.7,6.7,0,0,0,3.671-8.716Z",
    transform: "translate(-316.914 -68.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.775,394.228a14,14,0,0,1-11.438,16.127L444.689,430.536A13.98,13.98,0,0,1,440,402.972L558.648,382.79a14,14,0,0,1,16.127,11.438Z",
    transform: "translate(-304.12 -80.421)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.944,525.534a9.128,9.128,0,0,1-12.894.051L536.327,398.863a9.118,9.118,0,0,1,12.843-12.945L676.894,512.639a9.127,9.127,0,0,1,.051,12.894Z",
    transform: "translate(-281.415 -80.274)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.804,
    cy: 15.804,
    r: 15.804,
    transform: "translate(245.567 301.32)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.451,177.115c-24.259,38.139-61.272,63.45-106.919,80.077a8.581,8.581,0,0,1-12.013-1.724h0c-24.795-33.106-19.2-80.421,13.528-105.718A75.455,75.455,0,0,1,476.49,164.187l.686.916a8.581,8.581,0,0,1-1.724,12.013Z",
    transform: "translate(-322.936 -134.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.278,164.187A75.456,75.456,0,0,1,736.72,149.75c32.724,25.3,38.323,72.612,13.528,105.718h0a8.581,8.581,0,0,1-12.013,1.724c-42.375-16.224-77.126-44.3-106.919-80.077a8.581,8.581,0,0,1-1.724-12.013Z",
    transform: "translate(-261.088 -134.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.712,581.311a6.7,6.7,0,0,0-2.57,9.1l38.588,68.957a6.686,6.686,0,0,0,11.669-6.53l-38.588-68.957A6.7,6.7,0,0,0,621.712,581.311Z",
    transform: "translate(-263.155 -37.745)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.731,583.882l-38.588,68.957a6.686,6.686,0,1,0,11.67,6.53L472.4,590.412a6.686,6.686,0,1,0-11.67-6.53Z",
    transform: "translate(-305.645 -37.745)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 20.667,
    r: 20.667,
    transform: "translate(381.724 597.946)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 20.667,
    r: 20.667,
    transform: "translate(396.312 69.125)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 20.667,
    r: 20.667,
    transform: "translate(239.489 20.498)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 20.667,
    r: 20.667,
    transform: "translate(89.96 66.694)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 20.667,
    r: 20.667,
    transform: "translate(103.333 597.946)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.7,593.34l.817,2.066H458.7Z",
    transform: "translate(749.086 340.151)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1102.232 573.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.667,
    height: 44,
    transform: "translate(178.539 53.775)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.455,271.139A28.339,28.339,0,1,0,260.795,242.8,28.339,28.339,0,0,0,232.455,271.139Z",
    transform: "translate(-70.615 -237.048)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.391,0H55.858V61.19L-2.516,53.952Z",
    transform: "translate(145.595 187.566)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.6,535.9s2.358,4.727,5.588,10.4c1.263,2.235,2.671,4.638,4.113,6.951,5.107,8.17,0,34.2,0,34.2l11.176,1.531,11.176-5.588,2.045-18.887V550.7l-12.741-14.249-5.588-6.169Z",
    transform: "translate(-574.603 -143.004)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.527,457.52s27.057,57.679,26.029,62.786,15.825,45.944,15.825,45.944c3.844,1.81,10.908-.793,17.569-4.247a137.766,137.766,0,0,0,14.529-8.941l.983-.693.592-.425L754.641,428.921,793.936,400.1l2.906-2.135L814.411,385l-53.645,9.7s-1.866-.235-11.735,5.286c-4.739,2.649-11.321,6.616-20.419,12.584C700.572,430.978,723.527,457.52,723.527,457.52Z",
    transform: "translate(-636.171 -160.087)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.506 224.913)",
    opacity: 0.007
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.527,457.52s27.057,57.679,26.029,62.786,15.825,45.944,15.825,45.944c3.844,1.81,10.908-.793,17.569-4.247a137.766,137.766,0,0,0,14.529-8.941l.983-.693.592-.425L754.641,428.921,793.936,400.1l2.906-2.135L814.411,385l-53.645,9.7s-1.866-.235-11.735,5.286c-4.739,2.649-11.321,6.616-20.419,12.584C700.572,430.978,723.527,457.52,723.527,457.52Z",
    transform: "translate(-714.68 -385)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M734.357,544.446s13.277-2.045,8.672,19.4c0,0-.2,25.146-2.045,29.057s-22.464,9.187-26.029,5.107,3.555-27.037,3.555-27.037,6.18,5.736,12.61,1.122S734.357,544.446,734.357,544.446Z",
    transform: "translate(-564.802 -141.344)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.327,541.862a16.093,16.093,0,0,1,3.476,4.828,18.907,18.907,0,0,1,1.978,6.571c.134,1.743.414,3.476.7,5.2,1.274,7.276-3.61,28.834-3.61,28.834l19.4,3.062,7.141-7.655,1.531-16.842a61.029,61.029,0,0,1-3.062-17.881c0-4.392-2.235-8.315-4.47-11.176a30.731,30.731,0,0,0-5.174-5.13S683.236,538.286,687.327,541.862Z",
    transform: "translate(-508.574 -142.842)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.1,442.209s12.752,23.995,20.933,43.9c5.364,13.076,16.451,44.212,23.47,64.038l1.028,2.928c3.085,8.773,5.141,14.708,5.141,14.708a13.293,13.293,0,0,0,4.012-.593c1.207-.324,2.559-.76,4-1.3l1.62-.615c1.609-.626,3.353-1.352,5.018-2.112,8.114-3.621,16.764-8.337,19.9-10.058l1.185-.659A161.47,161.47,0,0,1,751.1,514.64c-4.593-21.435-20.419-52.527-20.419-52.527L728.633,451.9l38.289-5.107c28.845-14.417,14.831-42.837,6.594-55.455A74.487,74.487,0,0,0,768.967,385l-30.633,6.706s-4.828,1.542-15.557,6.292l-4.929,2.235c-6.013,2.76-13.411,6.314-22.352,10.874C665.344,426.351,678.1,442.209,678.1,442.209Z",
    transform: "translate(-562.139 -160.087)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.045,584.234A10.841,10.841,0,0,0,698,600.282c6.27-1.553,13.7-4.213,15.937-8.4,4.079-7.655,2.045-39.306,2.045-39.306l-5.365-7.913s.7,13.163-3.73,23.217-17.755-1.006-17.755-1.006Z",
    transform: "translate(-504.553 -141.313)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.125,493.584a10.353,10.353,0,0,0,15.744,2.038L692.3,513l-1.739-19.039L660.03,480.378a10.409,10.409,0,0,0-15.9,13.206Z",
    transform: "translate(-642.451 -409.544)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.264,499.311l12.708-17.542,61.221,28.941,76.183-14.294a26.1,26.1,0,0,1,30.915,25.605h0a26.13,26.13,0,0,1-26.054,26.15l-87.306.162Z",
    transform: "translate(-637.963 -408.627)",
    fill: "#3E629C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.129,656.112a5.354,5.354,0,0,1-2.484-.616L764.1,610.364l-.889-3.639-1.675-11.515-5.033-28.9c-.134-.29-.414-.765-.731-1.3-3.266-5.533-13.205-22.375,5.764-45.564l33.3-38.828,28.584-1.23.325.411A74.451,74.451,0,0,1,836.4,548.96l-2.976,53.753,3.192,10.856a29.954,29.954,0,0,1-.877,19.383l.732,17.578a5.37,5.37,0,0,1-5.342,5.582Z",
    transform: "translate(-619.203 -409.14)",
    fill: "#3E629C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.689,669.646a10.353,10.353,0,0,0,2.585-15.663l18.494-31.8-19.088,1.076-14.636,30.037a10.409,10.409,0,0,0,12.645,16.354Z",
    transform: "translate(-619.287 -382)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.063,673.95l-17.089-13.311,31.053-60.178-11.636-76.634a26.1,26.1,0,0,1,26.665-30.006h0a26.13,26.13,0,0,1,25.228,26.947l-2.875,87.258Z",
    transform: "translate(-618.398 -406.03)",
    fill: "#3E629C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.217,256.146c-3.481,5.648-.272,13.086,4.017,18.148s9.819,9.505,11.733,15.857c1.717,5.7.155,11.837-1.864,17.432s-4.529,11.174-4.737,17.118-2.257,1.568,3.342,3.575c5.746,2.059,12.539-1.177,18.074,1.4,7.209,3.353,9.065,19.561,16.924,20.765,4.837.741,9.1-8.052,10.448-12.754s.381-9.722-.6-14.516c-2.677-13.136-.492-15.331-3.169-28.467l-6.683-32.79c-1.33-6.526-2.908-13.506-7.813-18.012-5.993-5.506-15.027-5.636-23.158-5.306-7.471.3-15.243.814-21.747,4.5s-9.2,11.685-6.953,18.815c2.1-5.018,6.305-7.99,11.45-6.22",
    transform: "translate(-55.189 -238.49)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTimeManagement4Ss6);
export default __webpack_public_path__ + "static/media/undraw_time-management_4ss6.68819120c03648b63794c0b0230a8db2.svg";
export { ForwardRef as ReactComponent };